/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_This_ComputerInputs */



/**
* | output |
* | --- |
* | "This computer" |
*
* @param {License_This_ComputerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_this_computer = /** @type {((inputs?: License_This_ComputerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_This_ComputerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cet ordinateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Computer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo computer")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Этот компьютер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此电脑")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このコンピューター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह कंप्यूटर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Este computador")
	return /** @type {LocalizedString} */ ("This computer")
});